import { render } from "./CreatePost.vue?vue&type=template&id=36dd33c7&scoped=true"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-36dd33c7"

export default script